// extracted by mini-css-extract-plugin
export default {"summaryContainer":"SubIssuesSummary-module__summaryContainer__hR7zoMr"};